import PropTypes from "prop-types";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import getRandomColor from "../../utils/randomColors";

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="black" textAnchor={x > cx ? "start" : "end"} dominantBaseline="central">
      {`${(percent * 100).toFixed(2)}%`}
    </text>
  );
};

const MyPercentPie = ({ data, width }) => (
  <ResponsiveContainer width={width} height="100%">
    <PieChart width={400} height={400}>
      <Pie
        data={data}
        cx="50%"
        cy="50%"
        labelLine={false}
        nameKey="name"
        label={renderCustomizedLabel}
        outerRadius={80}
        fill="#40916c"
        dataKey="value"
      >
        {data.map((key) => (
          <Cell key={key} fill={getRandomColor(key.name)} />
        ))}
      </Pie>
      <Tooltip />
      <Legend />
    </PieChart>
  </ResponsiveContainer>
);

MyPercentPie.defaultProps = {
  data: [],
  width: 300,
};

MyPercentPie.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  width: PropTypes.number,
};
export default MyPercentPie;
